module.exports = __webpack_public_path__ + "media/img/Landing_Page/Scholarships2u_Feature-Testimonial_Tang-Wai-Xian-5f06986e1ca755beadb1c742eec67de1.jpg";